import React, { FC } from 'react';

import { Icon } from 'app/design-system/components/Icon';
import { Spinner } from 'app/design-system/components/Spinner';

import { SubmissionState } from '../../../constants';

import styles from './Icon.module.scss';

// ---

type SubmissionIconProps = {
  submission: SubmissionState;
  filledIcons?: boolean;
  size?: number;
};

const SubmissionIcon: FC<SubmissionIconProps> = ({
  submission,
  filledIcons = false,
  size = 24,
}) => {
  if (submission === SubmissionState.PROCESSING) {
    return (
      <Spinner size={size} />
    );
  }

  if (submission === SubmissionState.ACCEPTED) {
    return (
      <Icon className={styles.success}
            icon={filledIcons ? 'success-filled' : 'success'}
            data-test="submissionIcon-success"
            size={size} />
    );
  }

  if (submission === SubmissionState.REJECTED || submission === SubmissionState.FAILED) {
    return (
      <Icon className={styles.error}
            icon={filledIcons ? 'error-filled' : 'error'}
            data-test="submissionIcon-error"
            size={size} />
    );
  }

  return null;
};

export default SubmissionIcon;
